import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../requests/@types";
import api from "../../../services/api";
import { queryOptions } from "../../search/hooks";
import { ExpandedLocalDetails } from "../@types/expanded_local_details";
import { localSampleDetailsQueryKey } from "../queryKeys";

const useGetExpandedDetailsLocal = (
  sha1: string | undefined,
  sourceId?: number | undefined,
  relationshipId?: number
) => {
  const { data, isLoading, error } = useQuery<
    AxiosResponse<ExpandedLocalDetails>,
    ErrorResponse,
    ExpandedLocalDetails
  >({
    ...queryOptions,
    queryKey: localSampleDetailsQueryKey(sha1, sourceId, relationshipId),
    queryFn: () => api.expandedDetailsLocal(sha1, sourceId, relationshipId),
    select: ({ data: expandedDetails }) => expandedDetails
  });

  return { data, isLoading, error };
};

export default useGetExpandedDetailsLocal;
